import "../assets/css/Footer.css";

const Footer = () => {
  const nowYear = new Date().getFullYear(); 

  return (
    <footer>
        <div className="footer">
            <div className="we">
              <hr className="horizontal-line" />
              <img draggable="false" src="https://cdn.jaquesbot.fr/static/logo.webp" alt="Jaques's profile !" width="35px" height="35px" title="❤️ | Jaques's profile picture !" />
              <p>Jaques, un bot Discord boosté à l'IA. Créé pour améliorer votre expérience sur Discord.</p>  
              <p>Copyright Jaques&copy; | 2023-{nowYear}</p>
            </div>
        </div>
    </footer>
  );
};

export default Footer;
